import { render, staticRenderFns } from "./joinUsDetail.vue?vue&type=template&id=a8b65b0c&scoped=true"
import script from "./joinUsDetail.vue?vue&type=script&lang=js"
export * from "./joinUsDetail.vue?vue&type=script&lang=js"
import style0 from "./joinUsDetail.vue?vue&type=style&index=0&id=a8b65b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b65b0c",
  null
  
)

export default component.exports